import { RootState } from '~/store';

export const getAppsReducer = (state: RootState) => state.appsReducer;
